import { nameof } from '@work4all/data/lib/helper/nameof';

import { InboundInvoicePayment } from '@work4all/models/lib/Classes/InboundInvoicePayment.entity';
import { ReViewModel } from '@work4all/models/lib/Classes/ReViewModel.entity';
import { SortDirection } from '@work4all/models/lib/DataProvider';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { EntityTableV8, IEntityTableV8 } from '../entity-table/EntityTableV8';
import { useEntityDataTableV8 } from '../entity-table/use-entity-data-table-v8';
import schema from '../schemata/inboundInvoicePayment-table-schema.json';
import { EntityTableLayoutV8Props } from '../table/EntityTableLayoutV8';

const defaultSort = [{ field: 'id', direction: SortDirection.DESCENDING }];

export function RePaymentsTable(props: IEntityTableV8) {
  const dataTable = useEntityDataTableV8<InboundInvoicePayment, never>({
    ...props,
    schema: schema as never,
    defaultSort,
    innerEntityQuery: {
      parentEntity: Entities.reViewModel,
      fieldName: nameof<ReViewModel>('payments'),
    },
    enableMultiRowSelection: false,
  });

  const overrides: Partial<EntityTableLayoutV8Props> = {
    layout: 'table',
    areas: null,
    hideSearch: true,
    cardConfig: null,
    displayFooter: false,
    actions: {
      groupingEnabled: null,
    },
  };

  return <EntityTableV8 {...props} {...dataTable} overrides={overrides} />;
}
